
import ReactHTMLTableToExcel from "react-html-table-to-excel"
import moment from 'moment'

export const STPPreventiveSewerageQuality_A_ExportData = (props) => {
    const { ExcelData, name, FromDate, ToDate } = props
    return (
        <div style={{ display: 'inline', marginLeft: '0px' }}>
            <ReactHTMLTableToExcel
                id="test-table-xls-button"
                table="table-to-FarmerMasterExport"
                className="btn btn-primary float-end download-table-xls-button float-end btn btn-export btn-md mr-1 mb-1 ml-1"
                filename={name}
                sheet={name}
                buttonText="Export"
                style={{ borderColor: 'black' }}
            />


            <table id="table-to-FarmerMasterExport" style={{ display: 'none', width: '46%' }}>

                <h5><span>&emsp;</span></h5>

                {/* <h4 style={{ textAlign: 'center', fontSize: 16 }}>{name}</h4> */}


                <tr style={{ border: '1px solid black' }}>
                    <th colSpan={16} style={{ textAlign: 'center', fontSize: 16 }}>Navi Mumbai Muncipal Corporation</th>
                </tr>
                <tr style={{ border: '1px solid black' }}>
                    <th colSpan={16} style={{ textAlign: 'center', fontSize: 16 }}>STP Maintenance Department</th>
                </tr>
                <tr style={{ border: '1px solid black' }}>
                    <th colSpan={16} style={{ textAlign: 'center', fontSize: 16 }}>Project Name - {ExcelData && ExcelData.table && ExcelData.table.length > 0 ? ExcelData.table[0].projectName : '-'}</th>
                </tr>
                <tr style={{ border: '1px solid black' }}>
                    <th colSpan={16} style={{ textAlign: 'center', fontSize: 16 }}>Report Name - {name}</th>
                </tr>
                <tr style={{ border: '1px solid black' }}>
                    <th colSpan={16} style={{ textAlign: 'center', fontSize: 16 }}>
                        Report From Date - {FromDate ? moment(FromDate).format('DD-MM-YYYY') : '-'}
                        <span>&emsp;</span>
                        | To Date - {ToDate ? moment(ToDate).format('DD-MM-YYYY') : '-'}
                    </th>
                </tr>
                <thead>
                    <tr style={{ backgroundColor: '#254462', color: "#fff", border: '1px solid white', borderTop: "1px solid black" }}>
                        <th className="sr_no_col" rowSpan="2" style={{ borderLeft: "1px solid black" }}>Sr No.</th>
                        <th rowSpan="2">Date</th>
                        <th colSpan="2" className='new_grid'>BOD (Mg / L)</th>
                        <th colSpan="2" className='new_grid'>COD (Mg / L)</th>
                        <th colSpan="2" className='new_grid'>DO (Mg / L)</th>
                        <th colSpan="2" className='new_grid'>Flow (MLD)</th>
                        <th colSpan="2" className='new_grid'>PH</th>
                        <th colSpan="2" className='new_grid'>TDS (Mg / L)</th>
                        <th colSpan="2" className='new_grid' style={{ textAlign: "center", borderRight: "1px solid black" }}>Temperature (°C)</th>
                    </tr>
                    <tr style={{ backgroundColor: '#254462', color: "#fff", border: '1px solid white', borderTop: "1px solid white" }}>
                        <th className='new_grid'>inlet</th>
                        <th className='new_grid'>outlet</th>
                        <th className='new_grid'>inlet</th>
                        <th className='new_grid'>outlet</th>
                        <th className='new_grid'>inlet</th>
                        <th className='new_grid'>outlet</th>
                        <th className='new_grid'>inlet</th>
                        <th className='new_grid'>outlet</th>
                        <th className='new_grid'>inlet</th>
                        <th className='new_grid'>outlet</th>
                        <th className='new_grid'>inlet</th>
                        <th className='new_grid'>outlet</th>
                        <th className='new_grid'>inlet</th>
                        <th style={{ borderRight: "1px solid black" }}>outlet</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        ExcelData && ExcelData.length > 0 ? ExcelData.map((item) => {
                            return (
                                <tr style={{ width: "100%", border: "1px solid black" }}>
                                    <td style={{ textAlign: "center" }}>{item.srNo ? item.srNo : '-'}</td>
                                    <td>{item.readingDate ? item.readingDate : '-'}</td>
                                    <td>{item.boD_Mg_L_Inlet ? item.boD_Mg_L_Inlet : '0'}</td>
                                    <td>{item.boD_Mg_L_Outlet ? item.boD_Mg_L_Outlet : '0'}</td>
                                    <td>{item.coD_Mg_L_Inlet ? item.coD_Mg_L_Inlet : '0'}</td>
                                    <td>{item.coD_Mg_L_Outlet ? item.coD_Mg_L_Outlet : '0'}</td>
                                    <td>{item.dO_Mg_L_Inlet ? item.dO_Mg_L_Inlet : '0'}</td>
                                    <td>{item.dO_Mg_L_Outlet ? item.dO_Mg_L_Outlet : '0'}</td>
                                    <td>{item.flow_MLD_Inlet ? item.flow_MLD_Inlet : '0'}</td>
                                    <td>{item.flow_MLD_Outlet ? item.flow_MLD_Outlet : '0'}</td>
                                    <td>{item.pH_Inlet ? item.pH_Inlet : '0'}</td>
                                    <td>{item.pH_Outlet ? item.pH_Outlet : '0'}</td>
                                    <td>{item.tdS_Mg_L_Inlet ? item.tdS_Mg_L_Inlet : '0'}</td>
                                    <td>{item.tdS_Mg_L_Outlet ? item.tdS_Mg_L_Outlet : '0'}</td>
                                    <td>{item.temperature_C_Inlet ? item.temperature_C_Inlet : '0'}</td>
                                    <td>{item.temperature_C_Outlet ? item.temperature_C_Outlet : '0'}</td>
                                </tr>
                            )
                        })
                            :
                            <td colSpan={15}>No data found</td>
                    }
                </tbody>
            </table>
        </div>
    )
}